import { Record } from "immutable";

import { SpecTypeType } from "./spec/consts";
import { SpecType } from "./spec/Spec";

// TODO format dates on retrieval to make these comments unnecessary
export type AssignmentType = {
  id?: string;
  creatorId?: string;
  classId?: string;
  startDate?: string;
  // Needs to be formatted into an UTC string (i.e. moment().format()) otherwise will lead to 🐛s when we try to compare dates as strings
  dueDate?: string;
  // Needs to be formatted into an UTC string (i.e. moment().format()) otherwise will lead to 🐛s when we try to compare dates as strings
  name?: string;
  numAssignees?: number;
  autoEnrolNewUsers?: boolean;
  spec?: SpecType;
  specType?: SpecTypeType;
  assignmentCutoffDate?: string; // Needs to be formatted into an UTC string (i.e. moment().format()) otherwise will lead to 🐛s when we try to compare dates as strings
  status?: ReceivedAssignmentStatus;
};

export type OptionalAssignmentType = Partial<AssignmentType>;

export enum ReceivedAssignmentStatus {
  complete = "COMPLETE",
  late = "LATE",
  incomplete = "INCOMPLETE"
}

export const defaultAssignment: AssignmentType = {
  id: undefined,
  creatorId: undefined,
  classId: undefined,
  startDate: undefined,
  dueDate: undefined,
  specType: undefined,
  spec: undefined,
  name: undefined,
  numAssignees: undefined,
  autoEnrolNewUsers: undefined,
  assignmentCutoffDate: undefined,
  status: undefined
};

export default class Assignment extends Record(defaultAssignment) {}
